import React from "react";

import { IRowContext } from "./row-context.types";

export const defaultContext: IRowContext<any> = { row: {} };

const RowContext = React.createContext<IRowContext<any>>(defaultContext);
export default RowContext;
